var _dec, _class, _temp;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { styled } from "../../theme";
import { Divider } from "../divider/divider.component";
import { List } from "../list/list.component";
import { MenuService } from "./menu.service";
export
/**
 * A versatile menu for navigation.
 * Menu should contain MenuItem or MenuGroup components to provide a useful component.
 *
 * @extends React.Component
 *
 * @property {string} appearance - Appearance of the component.
 * Can be `default` or `noDivider`.
 *
 * @property {ReactElement<MenuItemProps> | ReactElement<MenuItemProps>[]} children -
 * Items to be rendered within menu.
 *
 * @property {IndexPath} selectedIndex - Index of selected item.
 * IndexPath `row: number, section?: number` - position of element in sectioned list.
 * Menu becomes sectioned when MenuGroup is rendered within children.
 * Updating this property is not required if marking items selected is not needed.
 *
 * @property {(IndexPath) => void} onSelect - Called when item is pressed.
 * Called with `row: number` for non-grouped items.
 * Called with `row: number, section: number` for items rendered within group,
 * where row - index of item in group, section - index of group in list.
 *
 * @property {ListProps} ...ListProps - Any props applied to List component,
 * excluding `renderItem` and `data`.
 *
 * @overview-example MenuSimpleUsage
 *
 * @overview-example MenuIndexType
 * Menu works with special index object - IndexPath.
 * For non-grouped items in menu, there is only a `row` property.
 * Otherwise, `row` is an index of option within the group, section - index of group in menu.
 * ```
 * interface IndexPath {
 *   row: number;
 *   section?: number;
 * }
 * ```
 *
 * @overview-example MenuNoMarkers
 * Pressing of menu items can be handled without marking items.
 *
 * @overview-example MenuAccessories
 * Items may contain inner views configured with `accessoryLeft` and `accessoryRight` properties.
 * Within Eva, item accessories are expected to be images or [svg icons](guides/icon-packages).
 *
 * @overview-example MenuGroups
 * And be grouped within `MenuGroup` component.
 *
 * @overview-example MenuDisabledOptions
 * Also, it may be disabled with `disabled` property.
 *
 * @overview-example MenuStyling
 * Menu and it's inner views can be styled by passing them as function components.
 * ```
 * import { MenuItem, Text } from '../..';
 *
 * <MenuItem
 *   title={evaProps => <Text {...evaProps}>USERS</Text>}>
 * </MenuItem>
 * ```
 *
 * @overview-example MenuTheming
 * In most cases this is redundant, if [custom theme is configured](guides/branding).
 *
 */
let Menu = (_dec = styled('Menu'), _dec(_class = (_temp = class Menu extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "service", new MenuService());

    _defineProperty(this, "clear", () => {
      this.props.onSelect && this.props.onSelect(null);
    });

    _defineProperty(this, "onItemPress", descriptor => {
      this.props.onSelect && this.props.onSelect(descriptor.index);
    });

    _defineProperty(this, "isItemSelected", descriptor => {
      return descriptor.index.equals(this.props.selectedIndex);
    });

    _defineProperty(this, "cloneItemWithProps", (element, props) => {
      const nestedElements = React.Children.map(element.props.children, (el, index) => {
        const descriptor = this.service.createDescriptorForNestedElement(el, props.descriptor, index);
        const selected = this.isItemSelected(descriptor);
        return this.cloneItemWithProps(el, _objectSpread(_objectSpread({}, props), {}, {
          selected,
          descriptor
        }));
      });
      return /*#__PURE__*/React.cloneElement(element, _objectSpread(_objectSpread({}, props), element.props), nestedElements);
    });

    _defineProperty(this, "renderItem", info => {
      const descriptor = this.service.createDescriptorForElement(info.item, info.index);
      const selected = this.isItemSelected(descriptor);
      return this.cloneItemWithProps(info.item, {
        descriptor,
        selected,
        onPress: this.onItemPress
      });
    });
  }

  get data() {
    return React.Children.toArray(this.props.children || []);
  }

  get shouldRenderDividers() {
    return this.props.appearance !== 'noDivider';
  }

  render() {
    const _this$props = this.props,
          {
      appearance
    } = _this$props,
          listProps = _objectWithoutProperties(_this$props, ["appearance"]);

    return /*#__PURE__*/React.createElement(List, _extends({
      ItemSeparatorComponent: this.shouldRenderDividers && Divider
    }, listProps, {
      data: this.data,
      renderItem: this.renderItem
    }));
  }

}, _temp)) || _class);